const hrHR= {
    login: {
      title: 'Prijava',
      sign_in_btn: 'Prijava'
    },
    bar: {
        logout: 'Odjava',
        languages: 'Jezici',
        settings: 'Otvorite postavke'
    },
    language: {
      name: 'Hrvatski (Hrvatska)',
    },
    attributePage: {
        title: 'Promjene atributa',
        viewChanges: 'Pogledajte promjene',
        dateTime: 'Datum',
        notificationType: 'Tip obavijesti',
        notificationValue: 'Vrijednost obavijesti',
        oldValue: 'Stara vrijednost',
        newValue: 'Nova vrijednost',
        accept: 'Prihvati',
        reject: 'Odbaci',
    },
    Home: 'Početna stranica',
    load: 'Provođenje početnog učitavanja ...',
    Requested: "Obavezno",
    Viewed: "Pregledano",
    Executing: "U izvršavanju",
    Completed: "Dovršeno",
    Expired: "Poveznica je istekla",
    Cancelled: "Otkazano",
    Error: "Greška",
    Rejected: "Odbačeno",
    error: 'Došlo je do greške; pokušajte ponovno kasnije.',
    displayname: 'Prikaži ime i prezime',
    givenname: 'Ime i prezime',
    surname: 'Prezime',
    email: 'E-adresa',
    mail: 'E-adresa',
    name: 'Ime i prezime',
    firstname: 'Ime i prezime',
    lastname: 'Prezime',
    footer_copyright: 'Sva prava pridržana.'
  };
  
  export default hrHR;
  